import React from 'react';
import { IDisabled } from '../types';

const MoreActionIcon = ({ disabled }: IDisabled) => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div
        className={disabled ? 'vbz-icon-beneficiaries-more-actions-disabled' : 'vbz-icon-beneficiaries-more-actions'}
      />
    </div>
  );
};

export default MoreActionIcon;
